import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-68480f16")

_pushScopeId("data-v-68480f16")
const _hoisted_1 = { class: "layout-widgets" }
const _hoisted_2 = { class: "p-grid p-d-none p-d-md-block" }
const _hoisted_3 = {
  key: 0,
  class: "p-col-12 p-pb-0 p-d-flex"
}
const _hoisted_4 = { class: "p-ai-center p-jc-center p-d-flex" }
const _hoisted_5 = { class: "p-col-12" }
const _hoisted_6 = { class: "welcome-board p-grid p-m-0" }
const _hoisted_7 = { class: "p-col-12 p-md-6 p-lg-6 p-p-0" }
const _hoisted_8 = { class: "p-d-flex p-ai-center welcome-left" }
const _hoisted_9 = { class: "welcome-container" }
const _hoisted_10 = {
  key: 0,
  class: "p-text-truncate p-mt-1 p-pl-6"
}
const _hoisted_11 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_12 = { class: "p-d-flex p-ai-center p-jc-center" }
const _hoisted_13 = { class: "p-grid" }
const _hoisted_14 = { class: "p-col-12 p-md-6" }
const _hoisted_15 = { class: "card widget-feature-box" }
const _hoisted_16 = { class: "p-primary" }
const _hoisted_17 = { class: "p-text-justify" }
const _hoisted_18 = { class: "p-col-12 p-md-6" }
const _hoisted_19 = { class: "card widget-feature-box" }
const _hoisted_20 = { class: "p-primary" }
const _hoisted_21 = { class: "p-text-justify" }
const _hoisted_22 = { class: "p-d-flex p-p-2 p-ai-center" }
const _hoisted_23 = { class: "p-m-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Board = _resolveComponent("Board")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Recent = _resolveComponent("Recent")!
  const _component_EditWorkspace = _resolveComponent("EditWorkspace")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.workspaceDetail?.type === 'SHARED')
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_Button, {
                label: 
            _ctx.$t('workspace.members', {
              members: _ctx.workspaceDetail?.userRoleList.length,
            })
          ,
                class: "p-button-text p-ml-auto",
                onClick: _ctx.onClickMembers
              }, null, 8, ["label", "onClick"]),
              _createVNode(_component_Divider, { layout: "vertical" }),
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("workspace.created", {
              time: _ctx.$moment(_ctx.workspaceDetail?.createdDate).fromNow(),
              user: _ctx.getFullname(_ctx.workspaceDetail?.ownerId),
            })), 1),
              (_ctx.isAdmin())
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    type: "Button",
                    icon: "pi pi-ellipsis-v",
                    onClick: _ctx.toggleWs,
                    class: "p-button-text",
                    "aria-haspopup": "true",
                    "aria-controls": "overlay_ws_menu"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Menu, {
                id: "overlay_ws_menu",
                ref: "wsMenu",
                model: _ctx.wsItems,
                popup: true,
                style: {"width":"240px"}
              }, null, 8, ["model"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("h1", {
                    class: ["p-m-0 p-pl-6 p-text-truncate", {
                    'p-pt-4': !_ctx.displayDescription,
                    'p-pt-2 p-pb-1': _ctx.displayDescription,
                  }]
                  }, _toDisplayString(_ctx.wsName), 3),
                  (_ctx.displayDescription)
                    ? (_openBlock(), _createBlock("h6", _hoisted_10, _toDisplayString(_ctx.workspaceDetail.desc), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_Board)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_ctx.workspaceId}/datasource`,
            class: "feature-box"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_15, [
                _createVNode("i", {
                  class: `bx-lg ${_ctx.getExperimentIcon('datasource')} p-primary`
                }, null, 2),
                _createVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t("menu.datasource")), 1),
                _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("menu.description.datasource")), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_ctx.workspaceId}/experiment`
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_19, [
                _createVNode("i", {
                  class: `bx-lg ${_ctx.getExperimentIcon('automl')} p-primary`
                }, null, 2),
                _createVNode("h2", _hoisted_20, _toDisplayString(_ctx.$t("menu.experiment")), 1),
                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("menu.description.experiment")), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("h4", _hoisted_23, _toDisplayString(_ctx.$t("label.recent")), 1),
        (_ctx.canEdit())
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              type: "Button",
              icon: "pi pi-plus",
              label: _ctx.$t('button.create'),
              class: "p-ml-auto",
              onClick: _ctx.toggle,
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu"
            }, null, 8, ["label", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Menu, {
          id: "overlay_menu",
          ref: "menu",
          model: _ctx.items,
          popup: true
        }, null, 8, ["model"])
      ]),
      _createVNode(_component_Recent, { workspaceId: _ctx.workspaceId }, null, 8, ["workspaceId"])
    ]),
    (_ctx.displayEditWorkspace)
      ? (_openBlock(), _createBlock(_component_EditWorkspace, {
          key: 0,
          onClicked: _ctx.offDialog,
          mode: _ctx.wsMode,
          workspace: _ctx.workspaceDetail
        }, null, 8, ["onClicked", "mode", "workspace"]))
      : _createCommentVNode("", true)
  ], 64))
})